import { useContext } from 'react';
import { PredefinedCommentFormContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/contexts/predefined-comment-form.context';

export const usePredefinedCommentFormContext = () => {
    const context = useContext(PredefinedCommentFormContext);

    if (!context) {
        throw new Error('usePredefinedCommentFormContext must be used within PredefinedCommentFormProvider');
    }
    return context;
};
